var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9815",
    "data-name": "Group 9815",
    transform: "translate(-12146 17993)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5305",
    "data-name": "Rectangle 5305",
    width: 24,
    height: 24,
    transform: "translate(12146 -17993)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Orar",
    d: "M19.182,4H2.818A.818.818,0,0,0,2,4.818V6.455H20V4.818A.818.818,0,0,0,19.182,4ZM2,8.091V19.545a.818.818,0,0,0,.818.818H19.182A.818.818,0,0,0,20,19.545V8.091ZM6.091,17.5a.818.818,0,1,1,.818-.818A.818.818,0,0,1,6.091,17.5Zm0-2.864a.818.818,0,1,1,.818-.818A.818.818,0,0,1,6.091,14.636Zm0-2.864a.818.818,0,1,1,.818-.818A.818.818,0,0,1,6.091,11.773ZM15.909,17.5H9.364a.818.818,0,1,1,0-1.636h6.545a.818.818,0,1,1,0,1.636Zm0-2.864H9.364a.818.818,0,1,1,0-1.636h6.545a.818.818,0,1,1,0,1.636Zm0-2.864H9.364a.818.818,0,0,1,0-1.636h6.545a.818.818,0,0,1,0,1.636Z",
    transform: "translate(12147 -17993.182)",
    fill: "#a1a1b3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleIcon);
export default __webpack_public_path__ + "static/media/ScheduleIcon.b95d5560f372c6780a8bdd13a211b8d9.svg";
export { ForwardRef as ReactComponent };